import { LanguageModel, LANGUAGES } from '@contler/core/dynamicTranslate';
import { getActualLanguage } from '@contler/translate/utils';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

type LanguageStore = {
  languages: LanguageModel[];
  actualLanguage: LanguageModel | null;
};

const initialState: LanguageStore = {
  languages: LANGUAGES.filter((language) => language.code !== 'uk'),
  actualLanguage: getActualLanguage(LANGUAGES),
};

export const languagesStore = signalStore(
  {
    providedIn: 'root',
  },
  withState(initialState),
  withMethods((store) => ({
    setHotelLanguages: (languages: LanguageModel[]) => {
      patchState(store, { languages });
    },

    setActualLanguage: (actualLanguage: LanguageModel) => {
      patchState(store, { actualLanguage });
    },
  })),
);
